import { render, staticRenderFns } from "./InvoiceSendTypeForm.vue?vue&type=template&id=15525707&"
import script from "./InvoiceSendTypeForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceSendTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceSendTypeForm.vue?vue&type=style&index=0&id=15525707&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports